import { useAppConstantsContext } from '@ltvco/refresh-lib/ctx';
import {
  closeSnackbar,
  invalidateSession,
  useSession,
} from '@ltvco/refresh-lib/v1';

import { goToLogin } from 'utils/goToLogin';

import { StyledAccountPageContainer } from '../components';

import { ActionButtons } from './ActionButtons';
import { AdditionalInfo } from './AdditionalInfo';
import {
  StyledNeedAssistanceContent,
  StyledNeedAssistanceTitle,
} from './components';
import { ContactInfo } from './ContactInfo';

interface NeedAssistanceProps {
  onUpgradePlanClick?: () => void;
}

export const NeedAssistance = ({ onUpgradePlanClick }: NeedAssistanceProps) => {
  const {
    links: { supportLink, billingLink, privacyLink, contactForm },
    data: { supportEmail, supportPhone, brandCustomerSupportSchedule },
    config: { socialMedia },
  } = useAppConstantsContext();
  const {
    session: { account },
  } = useSession();

  const customerSupportSchedule = brandCustomerSupportSchedule ?? {
    days: 'Mon - Fri',
    hours: '9am - 6pm EST',
  };

  // Click handlers

  const handleSupportClick = () => {
    window.open(supportLink, '_blank', 'noopener,noreferrer');
  };
  const handleBillingClick = () => {
    window.open(billingLink, '_blank', 'noopener,noreferrer');
  };
  const handlePrivacyClick = () => {
    window.open(privacyLink, '_blank', 'noopener,noreferrer');
  };
  const handleContactFormClick = () => {
    window.open(contactForm, '_blank', 'noopener,noreferrer');
  };

  const handleLogoutClick = async () => {
    try {
      await invalidateSession();
    } finally {
      closeSnackbar();
      goToLogin('https://www.beenverified.com');
    }
  };

  return (
    <StyledAccountPageContainer>
      <StyledNeedAssistanceTitle variant="h3">
        Need Assistance?
      </StyledNeedAssistanceTitle>
      <StyledNeedAssistanceContent>
        <ActionButtons
          onSupportClick={handleSupportClick}
          onBillingClick={handleBillingClick}
          onPrivacyClick={handlePrivacyClick}
          onUpgradePlanClick={onUpgradePlanClick}
        />
        <ContactInfo
          supportEmail={supportEmail}
          supportPhone={supportPhone}
          customerSupportSchedule={customerSupportSchedule}
          socialMedia={socialMedia}
          handleContactFormClick={handleContactFormClick}
        />
        <AdditionalInfo
          memberId={account?.account.user_info.user_code || ''}
          onLogoutClick={handleLogoutClick}
        />
      </StyledNeedAssistanceContent>
    </StyledAccountPageContainer>
  );
};
